import { useQuery } from "@tanstack/react-query";

import { useToast } from "~/hooks/use-toast";
import { supabase } from "~/integrations/supabase/client";

export const useUnreadContactAttempts = () => {
  const { toast } = useToast();

  const {
    data: unreadCount = 0,
    isLoading,
    error: queryError,
    refetch,
  } = useQuery({
    queryKey: ["contact-attempts", "unread-count"],
    queryFn: async () => {
      const { count, error } = await supabase
        .from("contact_attempts")
        .select("*", { count: "exact", head: true })
        .eq("is_read", false);

      if (error) {
        throw error;
      }

      return count || 0;
    },
    staleTime: 1000 * 30, // Data is fresh for 30 seconds
    gcTime: 1000 * 60 * 5, // Cache for 5 minutes
    refetchOnWindowFocus: true,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });

  // Handle errors with toast notifications
  const error = queryError?.message || null;

  if (queryError) {
    console.error("Error fetching unread contact attempts count:", queryError);
    toast({
      title: "Error",
      description: "No se pudo cargar el contador de cotizaciones no leídas.",
      variant: "destructive",
    });
  }

  return {
    unreadCount,
    isLoading,
    error,
    refetch,
  };
};
